import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, message } from 'antd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import { approveOrder } from '../../../Reducers/xbox';

function ApproveButton({ className, afterSuccess, orderId }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.xbox.approveOrder.isLoading,
    shallowEqual
  );

  const handleClick = useCallback(() => {
    dispatch(approveOrder(orderId))
      .then(() => {
        message.success('Order has been approved');
        afterSuccess();
      })
      .catch((error) => {
        if (error?.errors?.[0]) {
          message.error(`Failed to approve: ${error.errors[0].message}`);
        } else {
          message.error(`Failed to approve: ${error}`);
        }
      });
  }, [afterSuccess, dispatch, orderId]);

  return (
    <Button
      size="small"
      type="primary"
      className={[className, 'button_success']}
      loading={isLoading}
      disabled={isLoading}
      onClick={handleClick}
      icon={<CheckCircleOutlined />}
    >
      Approve
    </Button>
  );
}

ApproveButton.propTypes = {
  className: PropTypes.string,
  orderId: PropTypes.number.isRequired,
  afterSuccess: PropTypes.func.isRequired,
};

ApproveButton.defaultProps = {
  className: '',
};

export default ApproveButton;
